import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import {SideBar} from "../SideBar/SideBar.js";
import { Navbar } from '../Navbar/Navbar.js';

const MobileBannerVideoPanel = () => {
  const [videoId, setVideoId] = useState(null);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        const response = await axiosInstance.get('/bannervideo/mobile');
        const videoData = response.data;
        
        if (videoData && videoData.length > 0) {
          setVideoId(videoData[0]._id);
          setCurrentVideoUrl(videoData[0].Video);
        }
      } catch (error) {
        console.error('Failed to fetch video data:', error);
        setErrorMessage('Failed to fetch video data. Please try again later.');
      }
    };

    fetchVideoData();
  }, []);

  const handleFileChange = (event) => {
    setVideoFile(event.target.files[0]);
  };

  const handleVideoUpdate = async () => {
    if (!videoFile) {
      setErrorMessage('Please upload a video file');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('Video', videoFile);

      const response = await axiosInstance.put(`/bannervideo/mobile/${videoId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Video updated:', response.data);
      
      setCurrentVideoUrl(response.data.Video);
    } catch (error) {
      console.error('Failed to update video:', error);
      setErrorMessage('Failed to update video. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
<div className="flex">
  {/* Main Content */}
  <div className="flex-1 p-6 overflow-auto bg-gray-100">
    <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-xl">
      <div className="banner-video">
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">Edit Mobile Banner Video</h2>
        {currentVideoUrl && (
          <div className="mb-6">
            <video controls className="w-full rounded-lg shadow-md">
              <source src={currentVideoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        <input
          type="file"
          accept="video/*"
          onChange={handleFileChange}
          className="mb-4 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}
        <button
          onClick={handleVideoUpdate}
          disabled={loading}
          className={`px-6 py-3 text-white font-semibold rounded-lg transition-colors duration-300 ${
            loading ? 'bg-gray-500 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'
          }`}
        >
          {loading ? 'Updating...' : 'Update Video'}
        </button>
      </div>
    </div>
  </div>
</div>

  );
};

export default MobileBannerVideoPanel;
